import type { BidHistoriesPage } from '@/features/bidding/types/bidHistory'

export function checkIfActivationGroupHasBidsForTheDay(
  bidHistoriesPage: BidHistoriesPage | undefined,
  activationGroupUuid: string,
): boolean {
  const activationGroupDayHistory = bidHistoriesPage?.bidHistories.find(
    (bidHistory) => bidHistory.activationGroupUuid === activationGroupUuid,
  )

  if (!activationGroupDayHistory) {
    return false
  }

  return activationGroupDayHistory.bids.length > 1
}
